import React from 'react';

interface OriginSectionProps {
  formData: {
    provenance: string;
    connaissement: string;
  };
  onInputChange: (field: string, value: any) => void;
}

const OriginSection: React.FC<OriginSectionProps> = ({ formData, onInputChange }) => {
  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
      <h3 className="font-medium text-blue-900 text-sm mb-3">ORIGINE</h3>
      
      <div className="space-y-3">
        <div>
          <label className="block text-sm font-medium text-blue-800 mb-1">Provenance</label>
          <input
            type="text"
            value={formData.provenance}
            onChange={(e) => onInputChange('provenance', e.target.value)}
            placeholder="Lieu de provenance"
            className="w-full px-3 py-2 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm bg-white"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-blue-800 mb-1">Connaissement</label>
          <input
            type="text"
            value={formData.connaissement}
            onChange={(e) => onInputChange('connaissement', e.target.value)}
            placeholder="Numéro de connaissement"
            className="w-full px-3 py-2 border border-blue-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm bg-white"
          />
        </div>
      </div>
    </div>
  );
};

export default OriginSection;
